import { quickWebLogger } from '@quickweb/logger';
import { LogContext, LoggerInitConfig, User } from './quickWebLogger.interface';
import { LoggerInitializationConfig } from '@quickweb/logger/src/config/interfaces/parametersConfig';

export class QuickWebLoggerModule {
  static get operator(): string | null {
    return sessionStorage.getItem('operador')?.toLowerCase() || null;
  }

  static init(config: LoggerInitConfig) {
    const loggerConfig: LoggerInitializationConfig = {
      name: config.name,
      version: config.version,
      env: config.env,
      sigla: config.sigla,
      externalApplication: config.externalApplication,

      datadog: {
        logs: {
          clientToken: config.clientToken
        },
        rum: {
          applicationId: config.applicationId,
          clientToken: config.clientToken,
          sessionSampleRate: config.sessionSampleRate,
          maskSensitiveData: config.maskSensitiveData,
          traceSampleRate: config.traceSampleRate,
          trackUserInteraction: config.trackUserInteraction,
          trackResources: config.trackResources,
          trackLongTasks: config.trackLongTasks,
          allowedTracingUrls: config.allowedTracingUrls
        }
      }
    };

    quickWebLogger.init(loggerConfig);

    this.setUser({
      id: '',
      name: this.operator ?? ''
    });
  }

  static error(message: string, context: LogContext = {}) {
    quickWebLogger.logger.error(message, context);
  }

  static info(message: string, context: LogContext = {}) {
    quickWebLogger.logger.info(message, context);
  }

  static warn(message: string, context: LogContext = {}) {
    quickWebLogger.logger.warn(message, context);
  }

  static debug(message: string, context: LogContext = {}) {
    quickWebLogger.logger.debug(message, context);
  }

  static notice(message: string, context: LogContext = {}) {
    quickWebLogger.logger.notice(message, context);
  }
  static critical(message: string, context: LogContext = {}) {
    quickWebLogger.logger.critical(message, context);
  }

  static alert(message: string, context: LogContext = {}) {
    quickWebLogger.logger.alert(message, context);
  }
  static emergency(message: string, context: LogContext = {}) {
    quickWebLogger.logger.emergency(message, context);
  }

  static ok(message: string, context: LogContext = {}) {
    quickWebLogger.logger.ok(message, context);
  }

  static setUser(user: User) {
    quickWebLogger.rum.setUser(user);
  }

  static startView(pageName: string) {
    quickWebLogger.rum.startView({ pageName });
  }

  static async getUser() {
    return await quickWebLogger.rum.getUser();
  }

  static clearUser() {
    quickWebLogger.rum.clearUser();
  }

  static setUserProperty(key: string, value: any) {
    quickWebLogger.rum.setUserProperty(key, value);
  }

  static removeUserProperty(key: string) {
    quickWebLogger.rum.removeUserProperty(key);
  }
}
